/**
 * Utility to convert numbers to English words (PKR/Rupees format)
 */
export const numberToWords = (number) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const scalars = ['', 'Thousand', 'Million', 'Billion'];

    if (number === 0) return 'Zero';

    const words = [];
    let n = Math.floor(number);
    let scalarIdx = 0;

    while (n > 0) {
        let chunk = n % 1000;
        if (chunk > 0) {
            let chunkWords = [];
            let h = Math.floor(chunk / 100);
            let t = chunk % 100;

            if (h > 0) {
                chunkWords.push(units[h] + ' Hundred');
            }

            if (t > 0) {
                if (t < 20 && t >= 10) {
                    chunkWords.push(teens[t - 10]);
                } else {
                    let d = Math.floor(t / 10);
                    let u = t % 10;
                    if (d > 0) chunkWords.push(tens[d]);
                    if (u > 0) chunkWords.push(units[u]);
                }
            }
            if (scalars[scalarIdx]) {
                chunkWords.push(scalars[scalarIdx]);
            }
            words.unshift(chunkWords.join(' '));
        }
        n = Math.floor(n / 1000);
        scalarIdx++;
    }

    return words.join(' ') + ' Only';
};
